module.exports = __webpack_public_path__ + "img/swiper4.69de1acc.jpg";